import styled from '@emotion/styled'

import { breakpoint, breakpointMax } from '../../__styling/style-functions'
import { colors } from '../../__styling/settings/colors'
import { metrics } from '../../__styling/settings/metrics'

import { supports } from '../../__helpers/at-supports-helper'
import { SierraLayouts } from './Sierra'
import {
    horizontalDividers,
    verticalDividers,
} from '../../__styling/style-mixins'
import { ThemeMargins } from '../../__styling/settings/metrics'

export interface GridProps {
    verticalSpacing: keyof ThemeMargins | undefined
    cardLayout: SierraLayouts
}

export const StyledSierra = styled('div')<GridProps>(
    {
        margin: '0 auto',
        width: '100%',
        display: 'flex',
        flexWrap: 'wrap',
        position: 'relative',
    },
    ({ cardLayout, theme }) =>
        supports('display: grid', {
            display: 'grid',
            gridGap: theme.margins.gridGap,
            gridTemplateColumns: '100%',

            [breakpoint('md')]: {
                // For 2 items it's a 4 column grid, for 3 items it's a 5 column grid.
                gridTemplateColumns: `repeat(${cardLayout.length + 2}, 1fr)`,
            },
        }),
    ({ theme, verticalSpacing }) => ({
        marginBottom: verticalSpacing && theme.margins[verticalSpacing],
        paddingBottom:
            theme.kind === 'thewest' ? metrics.thewest.margins.sm : undefined,
    }),
)
export const StyledHeader = styled('div')((props) => ({
    display: 'block',
    marginBottom: props.theme.margins.md,
}))

interface SierraCardContainerProps {
    cardLayout: SierraLayouts
}

export const SierraCardContainer = styled('div')<SierraCardContainerProps>(
    {
        display: 'flex',
        justifyContent: 'flex-start',
        flexGrow: 1,
        flexShrink: 1,
        width: '100%',
    },
    ({ theme, cardLayout }) =>
        theme.kind === 'thewest' && {
            marginBottom: theme.margins.gridGap,
            position: 'relative',

            // Horizontal dividers only on small viewports for bottom of columns
            [breakpointMax('md')]: {
                '&::before': {
                    ...horizontalDividers,
                },
            },

            [breakpoint('md')]: {
                marginBottom: 0,
                flexGrow: 1,
                flexShrink: 1,

                // Vertical dividers
                '&:not(:first-child)::after': {
                    ...verticalDividers,
                },

                '&.heroCardContainer': {
                    // prettier-ignore
                    width: `calc(((100% / ${cardLayout.length + 2} * 3)) + (${theme.margins.gridGap}px * 2))`,
                    marginRight: theme.margins.gridGap,
                },

                '&.portraitCardContainer': {
                    // prettier-ignore
                    width: `calc((100% / ${cardLayout.length + 2}) - (${theme.margins.gridGap}px * 4))`,
                    borderBottom: `1px solid ${colors.thewest.greyDolphin}`,

                    '+ .portraitCardContainer': {
                        marginLeft: theme.margins.gridGap,
                    },
                },
            },
        },

    supports('display: grid', {
        marginBottom: 0,

        [breakpoint('md')]: {
            '&.heroCardContainer': {
                width: 'auto',
                marginRight: 0,
                gridColumnStart: 'span 3',
            },

            '&.portraitCardContainer': {
                width: 'auto',
                marginRight: 0,
                gridColumnStart: 'span 1',

                '+ .portraitCardContainer': {
                    marginLeft: 0,
                },
            },
        },
    }),
)
